import EECS from "../../img/code-projects/eecs.png"
import FEMTech from "../../img/code-projects/femtech.png"
import Frio from "../../img/code-projects/frio.png"
import Grotech from "../../img/code-projects/grotech.png"
import WDB from "../../img/code-projects/wdb.png"

export const CodeProjectData = [
    {
        name: "WDB",
        description:
            "Founder & President at Cal's first Web Dev organization. My pride and joy (= ",
        link: "http://webatberkeley.org",
        image: WDB,
    },
    {
        name: "EECS",
        description:
            "Helping to teach CS70 because that class was NoT eaSY when I took it.",
        link: "http://eecs70.org/",
        image: EECS,
    },
    {
        name: "FEMTech",
        description:
            "Teaching foundations of data science (DATA8) to UC Berkeley students.",
        link: "https://femtechberkeley.com/",
        image: FEMTech,
    },
    {
        name: "Frio",
        description:
            "Your virtual fridge assistant. Built backend on Flask and SQL.",
        link: "https://devpost.com/software/frio",
        image: Frio,
    },
    {
        name: "Grotech",
        description: "My greenest website yet. Built using the basic stack.",
        link: "https://grotech.berkeley.edu/",
        image: Grotech,
    },
]
